module.exports = __webpack_public_path__ + "static/media/contact-image.f32364de.png";